import { debounce } from 'lodash';
import { DependencyList, useCallback, useEffect } from 'react';

export const useDebouncedEffect = (effect: () => void, delay: number, deps: DependencyList) => {
    const debouncedEffect = useCallback(() => {
        const debounced = debounce(effect, delay);
        debounced();
        return () => debounced.cancel();
    }, [delay, effect]);

    useEffect(() => {
        debouncedEffect();
    }, [deps, debouncedEffect]);
};
